export class App {

  public name: string;
  public version: string;
  public date: Date;
}
